/*
 * AccountReroll — images pretes d'avance ET jamais servies en pleine resolution.
 *
 * CE QUI BLOQUAIT TOUT (mesure du 01/09/2026) : le serveur repond en 108 ms,
 * mais la PREMIERE image n'arrivait qu'a 8,8 s. En cause, des images sans aucun
 * parametre de taille dans leur URL — Shopify sert alors le PNG original :
 * Genshin_CustomAccount1.png 596 Ko, Dbl_T2_17GoldenFrieza.png 331 Ko,
 * Mavuika.png 303 Ko... Elles viennent du widget d'avis Judge.me, dont le JSON
 * embarque dans la page contient les URL brutes (« product_variant_image_url »).
 * Ces quelques megaoctets saturent la connexion EN MEME TEMPS que les images
 * des premieres sections : voila pourquoi aucune section n'apparaissait
 * immediatement, meme tout en haut de page.
 *
 * Le CDN Shopify redimensionne a la demande : il suffit d'ajouter `width=` a
 * l'URL. Une vignette de 300 px passe de ~300 Ko a ~25 Ko.
 *
 * INTERCEPTION SYNCHRONE. Une premiere version corrigeait les images avec un
 * debounce de 300 ms : trop tard, le navigateur avait deja lance — voire fini —
 * le telechargement de l'original (13 images, 3446 Ko passaient au travers).
 * Les <img> ajoutees sont donc desormais traitees IMMEDIATEMENT dans le
 * MutationObserver, avant que le chargement ne demarre. Le debounce ne sert
 * plus qu'au reste (anticipation et prechargement), qui n'est pas urgent.
 *
 * CORRECTIF DU 23/09/2026 — le script faisait lui-meme ralentir tout le site :
 *  - premierEcran() liberait en priorite haute toute image dont le haut est
 *    < 1,2 ecran. Une image CACHEE (display:none) a un rectangle a 0 : les
 *    272 icones des menus (136 jeux x 2 menus) passaient donc TOUTES en
 *    fetchpriority=high au chargement, devant les images des produits.
 *    -> on ignore desormais les images non affichees (largeur ou hauteur 0).
 *  - prechargeTout() liberait ensuite TOUTES les images lazy de la page par
 *    salves de 6 : le chargement differe ne servait plus a rien (507 requetes,
 *    2,5 Mo sur l accueil). Supprime : l anticipation a 1200 px suffit pour que
 *    les images soient pretes avant d arriver a l ecran.
 */
(function () {
  if (window.__arImagesAnticipees) return;
  window.__arImagesAnticipees = true;

  var AVANCE = 1200;   // px d'avance pour l'anticipation
  var MAXI = 600;      // largeur maximale demandee au CDN

  /* ---------------------------------------------- redimensionnement au CDN */

  /*
   * On ne touche qu'aux images Shopify SANS parametre de taille : celles du
   * theme ont deja `width=` et un srcset corrects, il ne faut surtout pas les
   * reecrire. On demande le double de la taille affichee pour rester net sur
   * les ecrans haute densite, plafonne a 600 px.
   */
  function redimensionne(img) {
    if (!img || img.nodeType !== 1 || img.tagName !== 'IMG') return;
    var src = img.getAttribute('src') || '';
    if (!src || src.indexOf('cdn.shopify.com') === -1) return;
    if (/[?&](width|height)=/.test(src)) return;
    if (img.getAttribute('data-ar-redim')) return;

    var large = Math.round(img.getBoundingClientRect().width) || img.width || 0;
    var cible = large ? Math.min(Math.round(large * 2), MAXI) : 300;

    img.setAttribute('data-ar-redim', '1');
    img.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + cible);
  }

  function redimensionneTout() {
    var imgs = document.querySelectorAll('img[src*="cdn.shopify.com"]:not([data-ar-redim])');
    for (var i = 0; i < imgs.length; i++) redimensionne(imgs[i]);
  }

  /** Traite un noeud fraichement insere et toutes les images qu'il contient. */
  function traiteNoeud(n) {
    if (!n || n.nodeType !== 1) return;
    if (n.tagName === 'IMG') { redimensionne(n); return; }
    if (!n.querySelectorAll) return;
    var imgs = n.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) redimensionne(imgs[i]);
  }

  /* ------------------------------------------------- chargement anticipe */

  function libere(img, prioritaire) {
    img.removeAttribute('loading');
    if (prioritaire) img.setAttribute('fetchpriority', 'high');
  }

  function premierEcran() {
    var h = window.innerHeight || 800;
    var w = window.innerWidth || 1200;
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;   // image cachee (menu ferme, onglet...)
      if (r.right <= 0 || r.left >= w) continue;   // diapositive hors ecran
      // menu deroulant ferme mais masque par opacite/visibilite (rectangle non nul)
      if (imgs[i].closest('details:not([open])')) continue;
      if (imgs[i].checkVisibility && !imgs[i].checkVisibility({ opacityProperty: true, visibilityProperty: true })) continue;
      if (r.top < h * 1.2) libere(imgs[i], true);
    }
  }

  function anticipe() {
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (!entrees[i].isIntersecting) continue;
        libere(entrees[i].target, false);
        obs.unobserve(entrees[i].target);
      }
    }, { rootMargin: AVANCE + 'px 0px' });
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) obs.observe(imgs[i]);
  }

  /*
   * L'observateur demarre AVANT tout le reste : Judge.me et les sections AJAX
   * inserent leurs images sans prevenir, et chaque milliseconde compte pour les
   * attraper avant le telechargement.
   */
  if (window.MutationObserver) {
    var minuteur;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var ajouts = muts[i].addedNodes;
        for (var j = 0; j < ajouts.length; j++) traiteNoeud(ajouts[j]);   // synchrone
      }
      clearTimeout(minuteur);
      minuteur = setTimeout(anticipe, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function demarre() {
    redimensionneTout();
    premierEcran();
    anticipe();
  }

  redimensionneTout();   // ce qui est deja dans le DOM au moment ou le script tourne
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
})();